module.exports = __webpack_public_path__ + "static/media/print-dark.be68f0ea.svg";